<template>
    <div class="app">
        <div class="info-control">
            <span>{{userInfo.name}}</span>
            <span>({{userInfo.idCardNo}})</span>
        </div>
        <div class="info-control" style="margin-top: 0.35rem">
            <span>联系电话:</span>
            <input class="phone" type="tel" placeholder="输入您的电话号码" maxlength="11" v-model="phone" @keyup=validPhone()>
        </div>
        <RegionSelect @doctorGroup="getGroupId"></RegionSelect>
        <div class="info-control" style="margin-top: 0.5rem;">
            <span>请选择您关注的重点</span>
        </div>
        <div class="info-control checkbox " :class="{active:items[index].isChoose}" @click="choose(index)" v-for="(item,index) in items">
            <span>{{item.name}}</span>
        </div>
        <div class="herf radio" :class="{active:item.isChooseProtocol,first:index == 0}" @click="chooseProtocol()" v-for="(item,index) in protocol">
            <a :href="item.href" class="disabled">{{item.title}}</a>
        </div>
        <div class="ok-wrap">
            <button class="btn-ok" :class="{disable: getSubmitState}"  @click="submit()">提交签约申请</button>
        </div>
        <tips v-model="showTips">
            <span slot="title" style="color: white">温馨提示</span>
            <div slot="list" class="tip-content">{{tips}}</div>
        </tips>
    </div>
</template>
<script>
    import RegionSelect from 'RegionSelect'
    import regionService from 'region.service'
    import tips from "Tips"
    export default {
        components: {
            RegionSelect,
            tips
        },
        beforeRouteLeave(to, from, next) {
            if(to.name == 'FamilyArgeeMent') {
                if(!from.meta.keepAlive) {
                    from.meta.keepAlive = true
                }
                next()
            }else{
                from.meta.keepAlive = false
                to.meta.keepAlive = false
                this.$destroy()
                next()
            }
        },
        data() {
            return {
                tips:'',
                userInfo:{},
                items: [],
                protocol: [{
                    title:'我已阅读并同意《用户协议》',
                    href: '',
                    isChooseProtocol:true,
                }],
                phone:'',
                doctorGroupId:'',
                followId:[],
                idcard:'',
                showTips: false,
                num:'',
            }
        },
        created() {
            let params = this.$route.query
            this.userInfo.name = params.userName
            this.idcard = params.idcard
            let temp = params.idcard
            this.userInfo.idCardNo = temp.slice(0,4)+'*******'+temp.slice(temp.length-4)
            this.phone = params.phone
            this.loadfollow()
            this.$router.afterEach((to,from)=>{
                if(from.name == 'FamilyDoctor' && to.name == 'NoSigned') {
                    let isRefresh = sessionStorage.getItem('isRefreshFamily')
                    if(isRefresh == '0') {
                        sessionStorage.setItem('isRefreshFamily',null)
                        window.location.reload()
                    }else{
                        sessionStorage.setItem('isRefreshFamily',0)
                    }
                }else if(from.name == 'NoSigned' && to.name == 'FamilyDoctor') {
                    sessionStorage.setItem('isRefreshFamily',0)
                }
            });
        },
        computed:{
            getSubmitState() {
                if(this.phone !== ''&&this.protocol[0].isChooseProtocol==true&&this.doctorGroupId !== "") {
                    for(var i = 0;i<this.items.length;i++) {
                        if(this.items[i].isChoose == true) {
                            return false
                        }
                    }
                    return true
                }else{
                    return true
                }
            }
        },
        methods:{
            choose (index) {
                this.items[index].isChoose = !this.items[index].isChoose
            },
            validPhone () {
                this.phone = this.phone.replace(/[^\d]/g, '')
            },
            submit () {
                var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.phone)) {
                    this.tips = '请输入正确的手机号码'
                    this.showTips = true
                    return
                }
                this.num = ''
                this.followId = []
                this.items.forEach(item => {
                    if(item.isChoose) {
                        this.followId.push(item.id)
                        this.num = this.num+1
                    }
                })
                if(this.num.length == 0) {
                    this.tips = '请选择关注领域'
                    this.showTips = true
                    return
                }
                if(this.doctorGroupId == "") {
                    this.tips = '请选择医生团队'
                    this.showTips = true
                    return
                }
                if(this.protocol[0].isChooseProtocol==false){
                    this.tips = '请选择协议'
                    this.showTips = true
                    return
                }
                regionService.submitSign({
                    doctorGroupId:this.doctorGroupId,
                    idcard:this.idcard,
                    followId:this.followId,
                    name:this.userInfo.name,
                    phone:this.phone,
                }).then((res) =>{
                    if(res.stateCode === 206) {
                        this.$utils.alert('您已提交过签约申请,请勿重新提交')
                    }
                    if(res.stateCode === 200){
                        this.$router.replace({name:'Review',query:{
                            hospitalName: res.data.hospitalName,
                            telephone: res.data.telephone
                        }});
                    }
                })
            },
            chooseProtocol() {
                this.$router.push('FamilyArgeeMent')
            },
            getGroupId (id) {
                this.doctorGroupId = id
            },
            loadfollow() {
                regionService.loadFollow({
                    page: 1,
                    rows: 15,
                }).then((res) => {
                    if(res.stateCode !== 200) {
                        this.$utils.alert(res.resultMsg);
                        return
                    }
                    res.data.rows.forEach(item => {
                        this.$set(item, 'isChoose', false)
                    })
                    this.items = this.items.concat(res.data.rows)
                })
            }
        }
    }
</script>

<style lang="scss">
.app {
    .message-pop-content{
        width: 13.0rem;
        left: 50%;
        margin-left: -6.5rem;
        height: 8.0rem;
        border-radius: 0.15rem;
    }
    .message-box-title {
        border-radius: 0.15rem 0.15rem 0 0;
    }
    .message-scroll{
        border-radius:  0 0 0.15rem 0.15rem;
    }
    .popup-message-box {
        background-color: rgba(0, 0, 0, 0.5);
    }
    .tip-content {
        text-align: center;
        padding: 1.75rem 0;
    }
    a.disabled {
        pointer-events: none;
    }
}
</style>

<style lang="scss" scoped>
.app {
    background-color: #EFF3F6;
    padding-bottom:3.75rem;
    .info-control {
        position: relative;
        height: 1.8rem;
        line-height: 1.8rem;
        background-color: #fff;
        padding-left: 0.25rem;
        span {
            margin-left: 0.45rem;
        }
        .phone {
            height: 1.25rem;
            padding: 1rem 0.25rem;
            border: none;
        }
        &.region:before{
            position: absolute;
            content: '';
            width: 0.425rem;
            height: 0.675rem;
            top:50%;
            right:0.875rem;
            margin-top: -0.335rem;
            background: url(../../../static/img/more-arrow.png) no-repeat;
            background-size: 100% 100%;
        }
        &.checkbox {
            padding-left: 1.25rem;
        }
        &.checkbox:before {
            position: absolute;
            content: '';
            width: 0.75rem;
            height: 0.75rem;
            left: 0.7rem;
            top:50%;
            margin-top: -0.375rem;
            background: url(../../../static/img/btn-select.png) no-repeat;
            background-size: 100% 100%;
        }

        &.checkbox.active:before {
            background-image: url(../../../static/img/btn-select-b.png);
        }
    }
    .herf {
        position: relative;
        padding-left: 2.0rem;
        font-size: 14px;
        a{
            color: #51A8EC;
        }
        &.radio:before{
            position: absolute;
            content: '';
            width: 0.75rem;
            height: 0.75rem;
            left: 0.875rem;
            top: 50%;
            margin-top: -0.375rem;
            background: url(../../../static/img/btn-mul-select.png);
            background-size: 100% 100%;
        }
        &.radio.active:before {
            background-image: url(../../../static/img/btn-mul-select-b.png);
        }

        &.first{
            margin-top: 0.75rem;
            margin-bottom: 0.75rem;
        }
    }
    .ok-wrap {
        position: fixed;
        height: 2.5rem;
        bottom: 0.25rem;
        left: 0.5rem;
        right: 0.5rem;
        .btn-ok {
            letter-spacing:1px;
            &.disable {
                color: #fff;
                background-color: #CCCCCC;
                box-shadow: inset 0 0 0 0 rgba(255, 255, 255, 0.1), inset 0 0 0 rgba(209, 209, 209, 0.1), inset 0 0 0 rgba(255, 255, 255, 0.01), inset 0 -0.03em 0 rgba(255, 255, 255, 0.17), inset 0 -0.3em 0 rgba(192, 192, 192, 1);
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// NoSigned.vue?0b23a7d8